import { render, staticRenderFns } from "./StealLossReportFollowUpPage.vue?vue&type=template&id=f45d8424&scoped=true"
import script from "./StealLossReportFollowUpPage.vue?vue&type=script&lang=js"
export * from "./StealLossReportFollowUpPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f45d8424",
  null
  
)

export default component.exports